module.exports = __webpack_public_path__ + "img/sequence-kyoto-gojo-sp@2x.76c70063.jpg";